import { Tooltip, styled, tooltipClasses } from "@mui/material";
import { chartColorCodes } from "./ColorCodes"
import { Buffer } from 'buffer';

// Import icons
import { RxDashboard } from "react-icons/rx";
import { LuCloudCog } from "react-icons/lu";
import {
    SiGooglebigquery,
    SiAmazonec2,
    SiAmazonecs,
    SiAwslambda,
    SiAmazonrds
} from "react-icons/si";
import { BiChip } from "react-icons/bi";
import { DiDatabase } from "react-icons/di";
import { VscRunAll } from "react-icons/vsc";
import { HiOutlineDocumentReport } from "react-icons/hi";
import {
    FaHandHoldingDollar,
    FaArrowsToDot,
    FaUsers
} from "react-icons/fa6";
import { CgInsights } from "react-icons/cg";
import {
    MdLabelOutline,
    MdOutlineInventory,
    MdOutlineSettings
} from "react-icons/md";
import { IoNotifications } from "react-icons/io5";
import {
    TbCloudNetwork,
    TbCloudDollar,
    TbFileInvoice
} from "react-icons/tb";
import {
    BsBucketFill,
    BsFillArchiveFill
} from "react-icons/bs";
import { AiOutlineSecurityScan } from "react-icons/ai";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";
import { PiFileMagnifyingGlass } from "react-icons/pi";


import DebugService from "../../services/DebugService";
import { CONST_ROUTE_PATH } from "../../route/RouteConstants";
import { useLocation } from "react-router-dom";

import { format } from 'date-fns';

export const CONST_SITE_LABEL = process.env.REACT_APP_SITE_LABEL
export const CONST_BUSINESS_NAME = process.env.REACT_APP_BUSINESS_NAME
export const CONST_BUSINESS_MAIL = process.env.REACT_APP_BUSINESS_MAIL
export const CONST_BUSINESS_PHONE = process.env.REACT_APP_BUSINESS_PHONE
export const CONST_BUSINESS_ACCOUNT_ID = process.env.REACT_APP_BUSINESS_ACCOUNT_ID
export const CONST_BUSINESS_ACCOUNT_EXTERNAL_ID = process.env.REACT_APP_BUSINESS_ACCOUNT_EXTERNAL_ID
export const CONST_BUSINESS_HOST = process.env.REACT_APP_BUSINESS_HOST
export const CONST_CLOUDFORMATION_LINK = process.env.REACT_APP_BUSINESS_CLOUDFORMATION
export const CONST_ONBOARD_CLOUDFORMATION_LINK = process.env.REACT_APP_BUSINESS_ONBOARD_CLOUDFORMATION
export const CONST_ONBOARD_AWS_POLICY_LINK = process.env.REACT_APP_AWS_ONBOARD_AUTO_POLICY_LINK
export const CONST_ONBOARD_AZURE_CUSTOM_ROLE_JSON = process.env.REACT_APP_AZURE_CUSTOM_ROLE_JSON
export const CONST_EKS_CLUSTER_ACCESS_OPENCOST_INSTALLATION_GUIDE = process.env.REACT_APP_EKS_CLUSTER_ACCESS_OPENCOST_INSTALLATION_GUIDE

export const CONST_CONTACT_US_COMPLETE_STATUS = 'Completed'
export const CONST_CONTACT_US_PENDING_STATUS = 'Pending'
export const CONST_CASE_CONTACT_US = 'CONTACTUS'
export const CONST_CASE_APPOINTMENT_BOOKING = 'APPOINTMENTBOOKING'

export const TRIAL_SUBSCRIPTION_DATA_LIMIT = 5

export const MESSAGES = {
    NAME_REQ: 'Name is required',
    FNAME_REQ: 'First Name is required',
    LNAME_REQ: 'Last Name is required',
    EMAIL_REQ: 'Email is required',
    EMAIL_VALID: 'Please enter a valid email',
    PHONE_REQ: 'Phone Number is required',
    ORGANIZATION_REQ: 'Organization is required',
    MESSAGE_REQ: 'Message is required',
    USER_NOT_REGISTERED: 'User is not registered. Please sign up',
    PASSWORD_VALID: 'Password is not valid',
    PASSWORD_CONFIRM_MATCH: 'Password and Confirm Password do not match',
    CAPTCHA_REQUIRED: 'Please verify that you are not a robot',


    CONTACT_US_SAVE_SUCCESS: 'Thank you for your details. We will get back to you soon.',
    APPOINTMENT_BOOKING_SAVE_SUCCESS: 'Appointment is created successfully. Please check your mail box for more details. Please sign up to explore our services.',
    PASSWORD_REQUEST_SUCCESS: 'Reset Password link has been mailed to your registered email. Please check your inbox.',
    PASSWORD_RESET_SUCCESS: 'Password is reset successfully. Please ',
    VERIFY_EMAIL_SUCCESS: 'Email is verified successfully. Please go to ',
    VERIFY_EMAIL_LINK_SUCCESS: 'Link sent successfully. Please check your mailbox ',
}

export const QUERY_LOG_ACCESS_LIST = (process.env.REACT_APP_PO_LIST || '').split(',')

/**
 * Local and Session storage key list
 */
export const STORAGE_KEYS = {
    REDIRECT_URL: 'REDIRECTURL',
    PLAN_PRICE: 'BUYPLAN',
    LOCAL_USER_DETAILS: 'userDetails',
    LOCAL_API_TOKEN: 'apiToken',
    LOCAL_LOGIN_TOKEN: 'loginToken',
    CHAT_PDF_FILE: 'chatPDFFile',
    CHAT_PDF_FILENAME: 'chatPDFFileName',
    PLATFORM: 'platform',
    ACCOUNT_ID: 'accountId',
    CURRENT_ROUTE: 'currentRoute',
    SUBSCRIPTION_STATUS: 'subscriptionStatus',
    AI_CHATBOT_REQUEST_DATA: 'aiChatbotRequestData',
}

/**
 * Registration type constants
 */
export const REGISTRATION_TYPE = {
    MANUAL: 'NORMAL',
    GOOGLE: 'GOOGLE'
}

/**
 * User onboard status
 */
export const ONBOARD_STATUS = {
    LINKED: 'LINKED',
    NOT_LINKED: 'NOT_LINKED'
}

export const BLOCK_CONTAINER_ICON = {
    SAVING: 'saving',
    BUCKET: 'bucket',
    SAVING_HAND: 'savinghand',
    SERVICE_HAND: 'servicehand',
    INVENTORY_SUMMARY: 'inventorysummary',
    INVENTORY_INSTANCE: 'inventory-instance',
    SETUP_INFRASTRUCTURE: 'setup-infrastructure',
    TOTAL_REGION: 'totalregion',
    TOTAL_USERS: 'totalusers',
    ACTIVE_USERS: 'activeusers',
    INACTIVE_USERS: 'inactiveusers',
    SECURITY_SCAN: 'security-scan',
}

/**
 * Service List for Menu
 */
export const MENU_SERVICE_LIST = [
    { label: 'Clouds Support', path: '' },
    { label: 'DevOps Support', path: '' },
    { label: 'Clouds Security', path: '' },
    { label: 'CustomizeDevops', path: '' },
    { label: 'Cloud Insights', path: '' },
]

/**
 * Payment status list
 */
export const PAYMENT_STATUS = {
    COMPLETED: 'COMPLETED',
    INPROCESS: 'INPROCESS',
    PENDING: 'PENDING',
    FAILED: 'FAILED'
}


export const SUBSCRIPTION_STATUS = {
    CREATED: 'created',
    AUTHENTICATED: 'authenticated',
    TRIAL_ACTIVE: 'trialActive',
    ACTIVE: 'active',
    PENDING: 'pending',
    HALTED: 'halted',
    CANCELLED: 'cancelled',
    EXPIRED: 'expired',
    COMPLETED: 'completed',
}

export const SUBSCRIPTION_ACCESS = {
    TRIAL_READ: 'TRIAL_READ',
    READ_ONLY: 'READ_ONLY',
    READ_WRITE: 'READ_WRITE',
}

/**
 * Payment status list
 */
export const PAYMENT_STATUS_CODE = {
    PSC001: 'API Error caught while buying plan',
    PSC002: 'Razorpay Payment Id not received',
    PSC003: 'Payment response not received',
}

/**
 * Payment Currency List
 */
export const PAYMENT_CURRENCY = {
    // USD
    USD: {
        title: 'USD',
        symbol: '$'
    },

    // INR
    INR: {
        title: 'INR',
        symbol: 'Rs'
    }
}

export const USER_ROLE = {
    OWNER: 'OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    ADMIN: 'ADMIN',
    READ_ONLY: 'READ_ONLY'
}

export const EBS_SNAPSHOT_DURATION = {
    ZERO_TO_SIX_MONTHS: {
        label: '0-6 Months',
        value: 'ZERO_TO_SIX_MONTHS'
    },
    SIX_MONTHS_TO_ONE_YEAR: {
        label: 'Less Than 1 Year',
        value: 'SIX_MONTHS_TO_ONE_YEAR'
    },
    OVER_ONE_YEAR: {
        label: '1+ Years',
        value: 'OVER_ONE_YEAR'
    },
}

export const AZURE_DB_TYPE = {
    'mysql': 'AZURE_MYSQL',
    'postgresql': 'AZURE_POSTGRESQL',
    'sql': 'AZURE_SQL',
}

export const AWS_EKS_NAMESPACE_AGG_TYPE = {
    POD: 'Pod',
    NAMESPACE: 'Namespace',
    CLUSTER: 'Cluster',
    NODE: 'Node',
    SERVICE: 'Service',
    CONTROLLER: 'Controller',
    CONTAINER: 'Container',
    DEPLOYMENT: 'Deployment',
    DAEMON_SET: 'DaemonSet',
}

export const BarColorCode = [
    // '#9ACD32',
    // '#FFFF00',
    // '#EE82EE',
    // '#FF6347',
    // '#008080',
    // '#4682B4',
    // '#D2B48C',
    // '#A0522D',
    // '#6A5ACD',
    // '#2E8B57',
    // '#C71585',
    // '#DAA520',
    // '#DC143C',
    // '#FFA500',
    // '#8B008B',
    // '#6B8E23',
    // '#0000FF',
    // '#BC8F8F',
    // '#0072B5',
    // '#F5DF4D',
    // '#00A170',
    // '#D2386C',
    // '#926AA6',
    // '#FDAC53'


    // '#e74c3c',
    // '#9b59b6',
    // '#3498db',
    // '#1abc9c',
    // '#f1c40f',
    // '#e67e22',
    // '#996633',
    // '#666633',
    // '#ff1a75',
    // ''

    "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40",
    "#8D6E63", "#4DD0E1", "#AED581", "#FF8A65", "#BA68C8", "#FFD54F",
    "#64B5F6", "#81C784", "#9575CD", "#F06292", "#7986CB", "#E57373",
    "#FFF176", "#4FC3F7", "#DCE775", "#D4E157", "#FFD600", "#C2185B",
    "#8BC34A", "#7C4DFF"
]

/**
 * EC2 Inventory Event Enum 
 */
export const INVENTORY_EVENTS = {
    INSTANCES: 'Instances',
    SCHEDULED: 'Scheduled Events',
    IDLE: 'Idle Events',
    ACTIVITY: 'Activity Events',
    MODIFICATION: 'Modification Events',
    MODIFICATION_CHANGES: 'Changes',
    MODIFICATION_REMOVED: 'Removed',
    MODIFICATION_ADDED: 'Added',
}

/**
 * Tag Based Page Enum 
 */
export const TAG_BASED_PAGE_LIST = {
    ACTIONS: 'Actions',
    SCHEDULED: 'Scheduled Events',
    UNTAGGED_LIST: 'Untagged List',
}

/**
 * AWS Instance List
 */
export const INSTANCE_CASE = {
    EC2: 'EC2',
    RDS: 'RDS',
    S3: 'S3',
    EBS: 'EBS'
}

export const ADD_NEW_ACCOUNT = 'ADD_NEW_ACCOUNT'

/**
 * Onboarding Steps Case Enum
 */
export const ONBOARDING_STEPS_CASE = {
    AUTOMATION: 'Automation',
    MANUAL: 'Manual'
}

export const PLATFORM = {
    AWS: 'AWS',
    AZURE: 'AZURE',
    GCP: 'GCP'
}

/**
 * @description To get random color from ColorCodeList
 * @returns {string} Color code
 */
export const randomColor = () => {
    if (chartColorCodes.length === 0) {
        return '#02B2AF'
    }

    const randomIndex = Math.floor(Math.random() * chartColorCodes.length);
    return chartColorCodes[randomIndex];
}


/**
 * @description HTML Tooltip
 */
export const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
    />
))
    (
        ({ theme }) => ({
            [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: 'white',
                color: 'rgba(0, 0, 0, 0.87)',
                maxWidth: 400,
                fontSize: theme.typography.pxToRem(0),
                border: '5px solid white',
            },
        })
    );

/**
 * @description Change the string into whole string
 * @param {string} str 
 * @returns {string} Whole string
 */
export const toWholeString = (str) => {
    if (str) {
        const splitNames = str.split('-')
        const result = []
        if (splitNames.length > 0) {
            for (let n of splitNames) {
                result.push(n[0].toUpperCase() + n.substr(1))
            }

            return result.join(' ')
        }
    }

    return str
}

/**
 * @description Change the string with underscore into whole string
 * @param {string} str 
 * @returns {string} Whole string
 */
export const toWholeStringByUnderscore = (str) => {
    if (str) {
        const splitNames = str.split('_')
        const result = []
        if (splitNames.length > 0) {
            for (let n of splitNames) {
                result.push(n[0].toUpperCase() + n.substr(1))
            }

            return result.join(' ')
        }
    }

    return str
}


/**
 * @description Capitalize only first letter of requested string
 * @param {*} str 
 * @returns 
 */
export const firstLetterCapital = (str) => {
    if (str) {
        const firstLetter = str[0].toUpperCase()
        const restLetters = str.substr(1).toLocaleLowerCase()

        return `${firstLetter}${restLetters}`
    }

    return str
}

/**
 * @description Return Menu icon name for requested icon value in sidebar menus on dashboard page
 * @param {*} iconValue Requested icon value for which name is to be fetched
 * @returns Icon name from Icons Material Library
 */
export const sidebarIcon = (iconValue) => {
    switch (iconValue) {
        case 'DASHBOARD':
            return <RxDashboard />
        case 'OPTIMIZATION':
            return <LuCloudCog />
        case 'BIG_QUERY':
            return <SiGooglebigquery />
        case 'COMPUTE_ENGINE':
            return <BiChip />
        case 'CLOUD_SQL':
            return <DiDatabase />
        case 'CLOUD_RUN':
            return <VscRunAll />
        case 'COST_CONTROL':
            return <FaHandHoldingDollar />
        case 'COST_ANOMALY_DETECTION':
            return <TbCloudDollar />
        case 'INSIGHTS':
            return <CgInsights />
        case 'LABELS':
            return <MdLabelOutline />
        case 'SETTINGS':
            return <MdOutlineSettings />
        case 'USERS':
            return <FaUsers />
        case 'INVOICE':
            return <TbFileInvoice />
        case 'NOTIFICATIONS':
            return <IoNotifications />
        case 'ACCESS_MANAGEMENT':
            return <TbCloudNetwork />
        case 'EC2':
            return <SiAmazonec2 />
        case 'ECS':
            return <SiAmazonecs />
        case 'EBS':
            return <BsFillArchiveFill />
        case 'LAMBDA':
            return <SiAwslambda />
        case 'RDS':
            return <SiAmazonrds />
        case 'S3':
            return <BsBucketFill />
        case 'ASG':
            return <FaArrowsToDot />
        case 'INVENTORY':
            return <MdOutlineInventory />
        case 'REPORTS':
            return <HiOutlineDocumentReport />
        case 'SECURITY':
            return <AiOutlineSecurityScan />
        case 'SCAN_RESULT':
            return <PiFileMagnifyingGlass />
        case 'SCAN':
            return <HiOutlineMagnifyingGlass />
        default:
            return ''
    }
}

/**
 * Get key list to display its value based on given type
 * @param {*} type 
 * @returns 
 */
export const getOptimizationBlockDataKeys = (type) => {
    switch (type) {
        // EC2
        case 'EC2': return ['currentOnDemandMonthlyPriceValue', 'recommendedOnDemandMonthlyPriceValue']
        case 'CUSTOM_EC2': return ['currentOnDemandMonthlyPriceValue', 'customRecommendedOnDemandMonthlyPriceValue']

        // EBS
        case 'EBS': return ['currentOnDemandMonthlyStoragePriceValue', 'recommendedOnDemandMonthlyStoragePriceValue']
        case 'CUSTOM_EBS': return ['OnDemandMonthlyStoragePriceValue', 'customOnDemandMonthlyStoragePriceValue']

        // RDS
        case 'RDS': return ['currentInstanceMonthlyCostValue', 'recommendedInstanceMonthlyCostValue']
        case 'CUSTOM_RDS': return ['CurrentInstanceMonthlyCostValue', 'CustomRecomendedRDSOnDemandMonthlyPriceValue']

        // Default
        default: return []
    }
}

/**
 * Create time slots for requested time period.
 * The method also checks for booked slots and remove them from the result
 * @param {*} timeperiodList Time period
 * @param {*} bookedTimeSlotList Booked time slots
 * @returns Time slots
 */
export const createTimeSlots = (timeperiodList, bookedTimeSlotList) => {
    if (timeperiodList.length === 0) {
        return []
    }

    DebugService.log('Create time slots for Time period list', timeperiodList)

    // Create start time list for given time period
    let startTimeList = []
    for (let i = 0; i < timeperiodList.length; i++) {
        DebugService.log(`Time period at index ${i}`, timeperiodList[i])

        let startTime = timeperiodList[i]['startTime']

        while (startTime <= timeperiodList[i]['endTime']) {
            startTimeList = [...startTimeList, startTime]
            const cloneStartTime = new Date(startTime)
            const newStartTime = new Date(cloneStartTime.setMinutes(cloneStartTime.getMinutes() + 30))
            startTime = newStartTime
        }
    }

    DebugService.log('Create time slots using Start time list', startTimeList)

    // Create slots using the created start time list 
    let timeSlotList = []
    for (let t = 0; t < startTimeList.length; t++) {
        const newSlot = {
            startTime: new Date(startTimeList[t]),
            endTime: new Date(startTimeList[t].setMinutes(startTimeList[t].getMinutes() + 30))
        }

        if (bookedTimeSlotList && bookedTimeSlotList.length > 0) {
            // Remove the booked slot list if provided
            if (!bookedTimeSlotList.some(s => (
                s.startTime.getTime() === newSlot.startTime.getTime() &&
                s.endTime.getTime() === newSlot.endTime.getTime())
            )
            ) {
                timeSlotList = [...timeSlotList, newSlot]
            }
        } else {
            timeSlotList = [...timeSlotList, newSlot]
        }
    }

    return timeSlotList
}

/**
 * @description Validate password
 * @param {*} value Password
 */
export const validatePassword = (value) => {
    let isValid = true

    if (value.length === 0) {
        isValid = false
    } else {
        isValid = value.length >= 6
    }

    return isValid
};

/**
 * @description Validate email
 * @param {*} value Email
 */
export const validateEmail = (value) => {
    let isValid = true
    if (value.length === 0) {
        isValid = false
    } else {
        isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
    }

    return isValid
};

/**
 * @description Validate Account ARN
 * @param {*} value Account ARN
 */
export const validateAccountARN = (value) => {
    let isValid = true
    if (value.length === 0) {
        isValid = false
    } else {
        isValid = /^arn:aws:iam::\d{12}:role\/[a-zA-Z0-9_-]+$/.test(value)
    }

    return isValid
};

/**
 * @description Validate Account Id
 * @param {*} value 
 * @returns 
 */
export const validateAccountId = (value) => {
    let isValid = true
    if (value.length !== 12) {
        isValid = false
    } else {
        isValid = /^\d{12}$/.test(value)
    }

    return isValid
};

/**
 * @description Parse google sign in response
 * @param {*} token 
 * @returns 
 */
export const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

/**
 * @description Retrieves random value for a given interger range
 * @param {*} min 
 * @param {*} max 
 * @returns 
 */
export const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random()
        * (max - min + 1)) + min;
};

/**
 * Normalize route paths by mapping legacy optimization paths to their shorter equivalents
 * @param {string} path 
 * @returns {string}
 */
export const normalizeRoutePath = (path) => {
    if (!path) return path;
    return path;
};

/**
 * Navigate to dashboard after Sign In or Sign Up
 * The function check for any requested RedirectUrl 
 * and navigtes to it, otherwise navigates to the Dashboard
 * 
 * @param {*} navigateCallback 
 */
export const navigateToDashboardPostLogin = (navigateCallback, isOnboarded) => {
    if (sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL) && isOnboarded) {
        navigateCallback(sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL))
    } else {
        navigateCallback(CONST_ROUTE_PATH.DASHBOARD)
    }
}

/**
 * Check if user is not subscribed
 * and redirect to pricing url if pricing redirect url is set
 * @param {*} navigateCallback 
 */
export const checkAndNavigateToPrice = (navigateCallback) => {
    DebugService.log(`Checking for price redirection`, window.location.pathname, sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL))
    navigateCallback(CONST_ROUTE_PATH.PRICING)

    // if (sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL) && sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL) === CONST_ROUTE_PATH.PRICING) {
    //     navigateCallback(CONST_ROUTE_PATH.PRICING)
    // } else {
    //     window.addEventListener('checkedUserSubscription', () => {
    //         if (sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL)  && sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL) === CONST_ROUTE_PATH.PRICING) {
    //             navigateCallback(CONST_ROUTE_PATH.PRICING)
    //         }
    //     })
    // }
}

/**
 * Format values into unit K and upto 2 decimal places
 * @param {*} value 
 * @returns 
 */
export const formatValuesInK = (value) => {
    const initValue = value
    const convertIntoK = initValue / 1000

    return convertIntoK.toFixed(2)
}

export const customArrayOperations = (data, latestRecordKey) => {

    let latestRecord = null

    if (data !== undefined && data.length > 0) {
        const sortedArray = data.sort((a, b) => b[latestRecordKey] - a[latestRecordKey])
        latestRecord = sortedArray[0]
    }

    return {
        latestRecord
    }
}

/**
 * Base64 encode
 * @param {*} value 
 * @returns 
 */
export const base64Encode = (value) => {
    if (!value) {
        return value
    }

    const jsonString = JSON.stringify(value)
    const buffer = Buffer.from(jsonString, 'utf-8')
    return buffer.toString('base64')
}

/**
 * Base64 decode
 * @param {*} value 
 * @returns 
 */
export const base64Decode = (value) => {
    if (!value) {
        return value
    }

    const buffer = Buffer.from(value, 'base64').toString('utf-8')
    return JSON.parse(buffer)
}

/**
 * Retrieve yesterday date
 * @returns 
 */
export const yesterdayDate = () => {
    const today = new Date()
    today.setDate(today.getDate() - 1)

    return today
}

/**
 * Find end of the day for requested Date object
 * @param {*} dateObj 
 * @returns 
 */
export const endOfDayForDateObj = (dateObj) => {
    if (dateObj) {
        dateObj.setHours(23, 59, 59, 999)
    }

    return dateObj
}

/**
 * Download html file by url
 * @param {*} htmlURL 
 * @param {*} filename 
 * @returns 
 */
export const downloadHTML = async (htmlURL, filename) => {

    if (!htmlURL) {
        return
    }

    try {
        // Fetch the HTML content
        const response = await fetch(htmlURL);

        if (!response.ok) {
            DebugService.log(`Download HTML: Something went wrong`, response)
            return
        }

        // Get the text content (HTML)
        const htmlContent = await response.text();

        // Create a Blob from the HTML content
        const blob = new Blob([htmlContent], { type: 'text/html' });

        // Create a download link
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename

        // Append to the document and click the link to start download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
    } catch (error) {
        DebugService.error('Download HTML: Error fetching or downloading the HTML page:', error);
    }
}

/**
 * Export requested JSON data
 * @param {*} jsonData 
 * @returns 
 */
export const downaloadJSON = (jsonData, filename) => {
    if (!Object.keys(jsonData).length) {
        DebugService.error('Download JSON: Data not available', jsonData)
        return
    }

    try {
        // Convert JSON to Blob
        const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });

        // Create a download link
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);

        // Start download and cleanup
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        DebugService.error('Download JSON: Something went wrong', error);
    }
}

export const exportJSONToCSV = (jsonData, filename) => {
    if (!Object.keys(jsonData).length) {
        DebugService.error('Export CSV: Data not available', jsonData)
        return
    }

    try {
        const regions = Object.keys(jsonData);
        const services = Object.keys(jsonData[regions[0]]);

        // Create CSV header
        const csvRows = [];
        csvRows.push(["Region", ...services].join(","));

        // Add each region's data as a row
        for (let i = 0; i < regions.length; i++) {
            const region = regions[i];

            // Insert an empty row before the last region's record
            if (i === regions.length - 1) {
                csvRows.push(new Array(services.length + 1).fill("").join(","));
            }

            const row = [region];
            for (const service of services) {
                row.push(jsonData[region][service] !== 0 ? jsonData[region][service] : '');
            }
            csvRows.push(row.join(","));
        }

        // Create a Blob and trigger download
        const csvString = csvRows.join("\n");
        const blob = new Blob([csvString], { type: 'text/csv' });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${filename}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        DebugService.error('Export CSV: Something went wrong', error);
    }
}

const formatResourceTags = (tags) => {
    if (!tags || typeof tags !== 'object') return 'N/A';
    return Object.entries(tags).map(([key, val]) => `${key}=${val}`).join('; ');
};

export const exportAccountScanToCSV = (parsedItems, filename) => {
    try {
        DebugService.log('Export CSV: Starting export process');

        if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
            DebugService.error('Export CSV: No parsed items found', parsedItems);
            return;
        }

        const headers = [
            'Status',
            'Severity',
            'ServiceName',
            'Region',
            'CheckID',
            'CheckTitle',
            'ResourceId',
            'ResourceTags',
            'StatusExtended',
            'Risk',
            'Recommendation',
            'Compliance'
        ];

        const csvRows = [];
        csvRows.push(headers.join(','));

        parsedItems.forEach((item) => {
            const row = [
                item?.Compliance?.Status || 'N/A',
                item?.Severity?.Label || 'N/A',
                item?.GeneratorId?.replace(/^prowler-/, '') || 'N/A',
                item?.Resources?.[0]?.Region || 'N/A',
                item?.Id?.replace(/^prowler-/, '') || 'N/A',
                item?.Title || 'N/A',
                item?.Resources?.[0]?.Id || 'N/A',
                formatResourceTags(item?.Resources?.[0]?.Tags),
                item?.Description || 'N/A',
                Array.isArray(item?.Types) ? item.Types.join('; ') : 'N/A',
                item?.Remediation?.Recommendation?.Text || 'N/A',
                Array.isArray(item?.Compliance?.RelatedRequirements)
                    ? item.Compliance.RelatedRequirements.join('; ')
                    : 'N/A'
            ];

            csvRows.push(row.map(val => `"${String(val).replace(/"/g, '""')}"`).join(','));
        });

        const csvString = csvRows.join('\n');

        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}.csv`;

        DebugService.log('Export CSV: Downloading file:', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        DebugService.error('Export CSV: Something went wrong', error);
    }
};

/*****************************************
 * Custom Hooks
 *****************************************/

export const useCurrentInstanceType = () => {
    const location = useLocation()
    let currentType = ''

    const splitLocationPathname = location.pathname.split('/')
    currentType = splitLocationPathname[splitLocationPathname.length - 1] ?? ''

    if (currentType.toLocaleLowerCase() === 'elastic-ip') {
        currentType = 'Elastic_IP'
    }

    if (currentType.toLocaleLowerCase() === 'data-transfer') {
        currentType = 'Data_Transfer'
    }

    if (currentType.toLocaleLowerCase() === 'cloud-cost-console') {
        currentType = 'Cloud_Cost_Console'
    }

    if (currentType.toLocaleLowerCase() === 'vm-scale-set') {
        currentType = 'vmss'
    }

    return {
        type: currentType.toLocaleLowerCase()
    }
}


export const mappedResponseList = [
    {
      in: 'hi, hello, hey, hi there, ',
      reply: 'Hi! How can I assist you today?'
    },
    {
      in: 'thanks, thank you, bye',
      reply: `You can also connect with us at ${CONST_BUSINESS_MAIL} for more information. Goodbye! Have a great day!`
    },
    {
      in: 'how are you, howz you, how are you doing',
      reply: `I'm doing well, thank you for asking!`
    }
];


export const formatAIResponse = (text) => {
    return text
        .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
        .replace(/\n\n/g, "<br/><br/>")
        .replace(/\n/g, "<br/>");
};
/**
 * Get scoped key for storage
 * @param {*} key 
 * @returns 
 */
export const getScopedKey = (key) => {
    const host = window.location.hostname;
    let prefix = 'dev';
  
    if (host.includes('staging')) {
      prefix = 'staging';
    } else if (host.includes('finops')) {
      prefix = 'prod';
    }

    return `${prefix}_${key}`;
};

/**
 * Set scoped item in localstorage
 * @param {*} key 
 * @param {*} value 
 */
export const setScopedItem = (key, value) => {
    const scopedKey = getScopedKey(key);
    localStorage.setItem(scopedKey, JSON.stringify(value));
};

/**
 * Get scoped item from localstorage
 * @param {*} key 
 * @returns 
 */
export const getScopedItem = (key) => {
    const scopedKey = getScopedKey(key);
    const item = localStorage.getItem(scopedKey);
    return item ? JSON.parse(item) : null;
};

/**
 * Remove scoped item from localstorage
 * @param {*} key 
 */
export const removeScopedItem = (key) => {
    const scopedKey = getScopedKey(key);
    localStorage.removeItem(scopedKey);
};

/**
 * @description Defines the list of allowed AI providers
 * that can be used for configuring AI chatbot access keys, to populate provider selection options
 * and to ensure only supported providers are allowed.
 * @author Ashish Sharma
 */
export const ALLOWED_PROVIDERS = [
    { value: 'GEMINI', label: 'Gemini' },
    { value: 'OPENROUTER', label: 'OpenRouter' },
];

/**
 * @description Generates a unique message ID for AI ChatBot messages
 * using a timestamp-based format.
 * @author Ashish Sharma
 */
export const generateAiChatBotMsgId = (prefix = 'ai') =>
  `${prefix}-${format(new Date(), 'yyMMddHHmmss')}`;

/**
 * @description
 * List of application routes where the AI Chat feature is disabled
 * or not required. When navigating to these routes, the AI chat
 * context should be reset or ignored.
 * @author Ashish Sharma
 */
export const AI_CHATBOT_DISABLED_ROUTES = [
  CONST_ROUTE_PATH.SETTINGS.BASE,
  CONST_ROUTE_PATH.K8S.BASE,
  CONST_ROUTE_PATH.SECURITY.BASE,
  CONST_ROUTE_PATH.DEVOPS.BASE
];

/*****************************************
 * Optimization page helpers
 *****************************************/

export const parseCost = (v) => {
  if (v == null) return 0;
  const n = parseFloat(typeof v === 'string' ? v.replace('$', '').replace(/,/g, '') : v);
  return isNaN(n) ? 0 : n;
};

export const parseSaving = (str) =>
  parseFloat((str ?? '0').replace('-$', '-').replace('$', '').replace('—', '0')) || 0;

export const formatSavingStr = (saving) => {
  const cents = Math.round((saving || 0) * 100);
  return cents < 0 ? `-$${(Math.abs(cents) / 100).toFixed(2)}` : `$${(cents / 100).toFixed(2)}`;
};

export const getCurrentMonthLabel = () => {
  const d = new Date();
  return `${d.toLocaleString('en-US', { month: 'short' })} ${d.getFullYear().toString().slice(-2)}`;
};

export const buildBaseCostKpis = ({
  countTitle, countValue, countSubtitle,
  current, saving, recommended,
  kpi4Title, kpi4Value, kpi4Subtitle,
}) => {
  const savingPercent = current > 0 ? ((saving / current) * 100).toFixed(1) : 0;
  const dailyAvg = current > 0 ? (current / 30).toFixed(2) : '0.00';
  return [
    { id: 1, title: countTitle, value: `${countValue}`, subtitle: countSubtitle, type: 't1' },
    { id: 2, title: `Total Cost (${getCurrentMonthLabel()})`, value: `$${current.toFixed(2)}`, subtitle: `$${dailyAvg} / day average`, type: 't2' },
    { id: 3, title: 'Recommended Saving Cost', value: `$${saving.toFixed(2)}`, subtitle: `${savingPercent}% potential saving`, type: 't3' },
    { id: 4, title: kpi4Title ?? 'Total Payable (after savings)', value: kpi4Value ?? `$${(recommended ?? 0).toFixed(2)}`, subtitle: kpi4Subtitle ?? 'If all recs applied', type: 't4' },
  ];
};

export const buildExportFilename = (pageName, accountId) => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  const date = `${pad(now.getDate())}_${pad(now.getMonth() + 1)}_${now.getFullYear()}`;
  const time = `${pad(now.getHours())}_${pad(now.getMinutes())}_${pad(now.getSeconds())}`;
  const acct = (accountId ?? 'unknown').replace(/[^a-zA-Z0-9]/g, '');
  return `${pageName}_${acct}_${date}_${time}.csv`;
};

export const exportCSV = (rows, columns, filename) => {
  const cols = columns.filter((c) => typeof c.label === 'string');
  const header = cols.map((c) => c.label).join(',');
  const csvRows = rows.map((row) =>
    cols.map((c) => {
      const val = row[c.key] ?? '';
      return `"${String(val).replace(/"/g, '""')}"`;
    }).join(',')
  );
  const blob = new Blob([[header, ...csvRows].join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};

export const CHART_COLORS = ['#f57c00', '#2196f3', '#2ea66f', '#8e24aa', '#e53935', '#00897b'];

export const buildGroupedCostDonut = (rows, groupKey) => {
  if (!rows.length) return null;
  const map = {};
  rows.forEach((r) => {
    const cost = parseFloat((r.cost ?? '$0').replace('$', '')) || 0;
    map[r[groupKey]] = (map[r[groupKey]] || 0) + cost;
  });
  const labels = Object.keys(map);
  const total = labels.reduce((s, k) => s + map[k], 0);
  if (!total) return null;
  return {
    labels,
    datasets: [{ data: labels.map((k) => parseFloat(map[k].toFixed(2))), backgroundColor: labels.map((_, i) => CHART_COLORS[i % CHART_COLORS.length]), borderWidth: 2, borderColor: '#fff' }],
  };
};